import { Component } from 'react'
import { connect } from 'react-redux'
import { submit } from 'redux-form'

export default function createSubmit (formName) {
  const HOC = class CreateSubmit extends Component {
    onClick = (evt) => {
      if (this.props.form.submitting || this.props.form.triggerSubmit) {
        evt.preventDefault()
        return
      }

      if (this.props.onClick) {
        this.props.onClick(evt)
      }

      if (!evt.defaultPrevented) {
        this.props.dispatch(submit(formName))
        evt.preventDefault()
      }
    }

    render() {
      const { onClick, dispatch, form = {}, ...props } = this.props
      return (
        <button {...props} disabled={!!(props.disabled || form.submitting || form.triggerSubmit)} type="button" onClick={this.onClick}>
          {this.props.children}
        </button>
      )
    }
  }
  return connect((state) => ({ form: state.form[formName] }))(HOC)
}
